import { z } from 'zod';

import type { User } from '@/types';

export const userEditSchema = z.object({
  name: z.string().trim().min(2).max(100),
  email: z.string().trim().email().optional().or(z.literal('')),
  dateOfBirth: z
    .string()
    .trim()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .or(z.literal('')),
  dateOfJoining: z
    .string()
    .trim()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .or(z.literal('')),
  designationLevel: z.string().trim().max(50).optional().or(z.literal('')),
  designationDept: z.string().trim().max(50).optional().or(z.literal('')),
  address: z.string().trim().max(255).optional().or(z.literal('')),
  pincode: z
    .string()
    .trim()
    .regex(/^\d{4,10}$/)
    .optional()
    .or(z.literal('')),
  city: z.string().trim().max(100).optional().or(z.literal('')),
  state: z.string().trim().max(100).optional().or(z.literal('')),
  employeeCode: z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9]{1,10}$/)
    .optional()
    .or(z.literal('')),
});

export type UserEditValues = z.infer<typeof userEditSchema>;

type UserEditPayload = Partial<
  Pick<
    User,
    | 'name'
    | 'email'
    | 'dateOfBirth'
    | 'dateOfJoining'
    | 'designationLevel'
    | 'designationDept'
    | 'address'
    | 'pincode'
    | 'city'
    | 'state'
    | 'employeeCode'
  >
>;

export const buildUserEditPayload = (values: UserEditValues): UserEditPayload => ({
  name: values.name,
  ...(values.email ? { email: values.email } : {}),
  ...(values.dateOfBirth ? { dateOfBirth: values.dateOfBirth } : {}),
  ...(values.dateOfJoining ? { dateOfJoining: values.dateOfJoining } : {}),
  ...(values.designationLevel ? { designationLevel: values.designationLevel } : {}),
  ...(values.designationDept ? { designationDept: values.designationDept } : {}),
  ...(values.address ? { address: values.address } : {}),
  ...(values.pincode ? { pincode: values.pincode } : {}),
  ...(values.city ? { city: values.city } : {}),
  ...(values.state ? { state: values.state } : {}),
  ...(values.employeeCode ? { employeeCode: values.employeeCode } : {}),
});
